// src/contexts/CartContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getCart } from '../services/cart';

const CartContext = createContext();

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be used within a CartProvider');
  return ctx;
};

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchCartCount = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await getCart();
      const cartItems = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
      const totalCount = cartItems.reduce((sum, item) => sum + Number(item.quantity || 1), 0);
      setCartCount(totalCount);
    } catch (error) {
      console.error('[CartContext] Failed to fetch cart count:', error);
      setCartCount(0);
    } finally {
      setLoading(false);
    }
  }, []);

  const updateCartCount = useCallback(() => {
    fetchCartCount();
  }, [fetchCartCount]);

  const value = {
    cartCount,
    loading,
    updateCartCount,
    fetchCartCount
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
